<template>
    <div class="page contact">
        <div class="contact-header">
            <h1>Contact Us</h1>
            <p>Get in touch with our team today! We're here to help with all your cleaning employment needs.</p>
        </div>

        <div class="contact-grid">
            <!-- Left: Contact Info -->
            <div class="contact-info card">
               
                <img src="@/assets/contactus.jpg" alt="Contact Us" class="contact-image" />
                <h2>Our Contact Information</h2>
                <ul>
                    <li><i class="fas fa-phone"></i> <strong>Phone:</strong> 865-352-8700</li>
                    <li><i class="fas fa-envelope"></i> <strong>Email:</strong>rthcleaners@rthgroupinc.com</li>
                    <li><i class="fas fa-map-marker-alt"></i> <strong>Office:</strong> 1169 Wears Valley Road, Pigeon
                        Forge, TN 37863</li>
                    <li><i class="fas fa-clock"></i> <strong>Business Hours:</strong>
                        <ul class="hours">
                            <li>Mon–Fri: 9:00 AM – 5:00 PM</li>
                            <li>Sat: Closed</li>
                            <li>Sun: Closed</li>
                        </ul>
                    </li>
                </ul>

                <!-- Google Map Embed -->
                

                <div class="social-icons">
                    <i class="fab fa-facebook"></i>
                    <i class="fab fa-instagram"></i>
                    <i class="fab fa-linkedin"></i>
                    <i class="fab fa-twitter"></i>
                </div>
            </div>

            <!-- Right: Message Form -->
            <div class="contact-form card">
                <h2>Send Us a Message</h2>
                <form @submit.prevent="sendMessage">
                    <input type="text" v-model="form.name" placeholder="Your Name" required />
                    <input type="email" v-model="form.email" placeholder="Email Address" required />
                    <input type="tel" v-model="form.phone" placeholder="Phone Number" />
                    <select v-model="form.subject" required>
                        <option disabled value="">Select subject</option>
                        <option>General Inquiry</option>
                        <option>Job Opportunity</option>
                        <option>Partnership</option>
                    </select>
                    <textarea v-model="form.message" placeholder="Your Message" rows="5" required></textarea>
                    <div class="newsletter">
                        <input type="checkbox" v-model="form.subscribe" />
                        Subscribe to our newsletter for job opportunities
                    </div>
                    <button type="submit" :disabled="loading">
                        {{ loading ? 'Submitting...' : 'Send Message' }}
                    </button>
                </form>

                <div class="quick-response">
                    <strong>Quick Response:</strong> We typically respond to all inquiries within 24 business hours. For
                    urgent matters, please call us directly.
                </div>
            </div>
        </div>

        <!-- FAQ Section -->
        <div class="faq card">
            <h2>Frequently Asked Questions</h2>
            <div class="faq-item">
                <strong>What type of cleaning positions do you offer?</strong>
                <p>
                    We specialize in connecting cleaners with various opportunities including residential cleaning,
                    commercial cleaning, hotel housekeeping, and specialized cleaning services.
                </p>
            </div>
        </div>
    </div>
</template>

<script setup>
import { notifySuccess, notifyError } from '@/services/notify'
import { ref } from 'vue'
import { db } from '@/firebase'
import { collection, addDoc, serverTimestamp } from 'firebase/firestore'
const loading = ref(false)
const form = ref({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: '',
    subscribe: false
})

const sendMessage = async () => {
    loading.value = true
    try {
        await addDoc(collection(db, 'contactMessages'), {
            name: form.value.name,
            email: form.value.email,
            phone: form.value.phone,
            subject: form.value.subject,
            message: form.value.message,
            subscribed: form.value.subscribe,
            sentAt: serverTimestamp()
        })

        notifySuccess('Thanks! Your message has been sent. We’ll be in touch soon.', 'Message sent')
        form.value = {
            name: '',
            email: '',
            phone: '',
            subject: '',
            message: '',
            subscribe: false
        }
    } catch (error) {
        notifyError('Your message could not be sent. Please try again.')
        console.error('Firestore Error:', error)
    }

    loading.value = false
}

</script>

<style scoped>
.page.contact {
    padding: 2rem;
    background: #f9f9f9;
}

.contact-header {
    text-align: center;
    margin-bottom: 2rem;
}

.contact-grid {
    display: flex;
    flex-wrap: wrap;
    gap: 2rem;
}

.card {
    background: white;
    padding: 2rem;
    border-radius: 12px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
    flex: 1;
    min-width: 300px;
}

.contact-info ul {
    list-style: none;
    padding: 0;
    line-height: 1.8;
}

.contact-info i {
    margin-right: 0.5rem;
    color: #6a1b9a;
}

.hours {
    padding-left: 1.5rem;
    margin-top: 0.5rem;
}

.social-icons {
    margin-top: 1rem;
}

.social-icons i {
    margin-right: 10px;
    font-size: 1.2rem;
    color: #6a1b9a;
    cursor: pointer;
}

.contact-form form {
    display: flex;
    flex-direction: column;
    gap: 1rem;
}

.contact-form input,
.contact-form select,
.contact-form textarea {
    padding: 0.75rem;
    border: 1px solid #ccc;
    border-radius: 8px;
}

button {
    background-color: #6a1b9a;
    color: white;
    border: none;
    padding: 0.75rem;
    border-radius: 8px;
    cursor: pointer;
    font-weight: bold;
}

button:hover {
    background-color: #4a148c;
}

.newsletter {
    font-size: 0.9rem;
    display: flex;
    align-items: center;
    gap: 0.5rem;
}

.quick-response {
    margin-top: 1rem;
    background: #f0f0f0;
    padding: 1rem;
    border-left: 5px solid #6a1b9a;
}

.faq {
    margin-top: 3rem;
}

.faq-item {
    margin-top: 1rem;
}

.map-embed {
    margin-top: 1rem;
}

.contact-image {
  width: 100%;
  height: auto;
  max-width: 100%;
  display: block;
  border-radius: 8px;
  margin-bottom: 1.5rem;
  object-fit: cover;
}
.contact-info.card {
  padding: 2rem 2rem 2.5rem;
}


</style>